"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeContainerStyles = void 0;

var makeContainerStyles = function makeContainerStyles() {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {
          "&.DhigSplitButton--wrapper": {
            position: "relative",
            width: "fit-content",
            margin: "unset"
          }
        }
      }
    }
  };
};

exports.makeContainerStyles = makeContainerStyles;